import icon from '@assets/img/icons/delegation-form.svg';
import { strings as membershipFormStrings } from '@data/membershipForm';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: membershipFormStrings.delegationForm,
    download: 'ダウンロード',
    fileName: '委任状.pdf',
    noForm: '委任状はアップロードされていません。',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  icon,
  order: 4,
};
